// Tabs opening this name on the same origin hear each other.
export const SESSION_CHANNEL_NAME = 'curious-admin-session';

// How long a waking tab waits for a sibling to hand over fresher tokens before using its own.
export const SESSION_REQUEST_WINDOW_MS = 300;
